import {
  apiClient,
  type MonthlyTourReportDateRangeDetailExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyTourReportDateRangeDetailsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyTourReportDateRangeDetailsQuery = {
  tenantKey: string
  query: MonthlyTourReportDateRangeDetailsRequestQuery
}

export type FetchMonthlyTourReportDateRangeDetailsResponse = {
  data: MonthlyTourReportDateRangeDetailExEntity
  pagination: PageEntity | null
}

/**
 * 月次支払レポートの日付範囲明細を取得する (#4829)。
 * 範囲集計の一覧行 1 件（パートナー）について、合計・月次調整・明細行（ページ分）を返す。
 */
export const fetchMonthlyTourReportDateRangeDetails = async (
  { tenantKey, query }: FetchMonthlyTourReportDateRangeDetailsQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyTourReportDateRangeDetailsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports.summary.details.$get({
      query,
      config: { signal }
    })
  return { data, pagination: pagination ?? null }
}
